import { Typography } from '@mui/material'

export const boldSome = (
  prefix: string,
  infix: string,
  postfix: string | JSX.Element,
) => (
  <Typography display="inline" variant="body2">
    {prefix} <strong>{infix}</strong> {postfix}
  </Typography>
)
